import EventScheduleService from 'src/modules/eventSchedule/eventScheduleService';
import Errors from 'src/modules/shared/error/errors';
import { getHistory } from 'src/modules/store';

const prefix = 'EVENTSCHEDULE_VIEW';

const eventScheduleViewActions = {
  FIND_STARTED: `${prefix}_FIND_STARTED`,
  FIND_SUCCESS: `${prefix}_FIND_SUCCESS`,
  FIND_ERROR: `${prefix}_FIND_ERROR`,

  doFind: (id) => async (dispatch) => {
    try {
      dispatch({
        type: eventScheduleViewActions.FIND_STARTED,
      });

      const record = await EventScheduleService.find(id);

      dispatch({
        type: eventScheduleViewActions.FIND_SUCCESS,
        payload: record,
      });
    } catch (error) {
      Errors.handle(error);

      dispatch({
        type: eventScheduleViewActions.FIND_ERROR,
      });

      getHistory().push('/event-schedule');
    }
  },
};

export default eventScheduleViewActions;
